export default [
  {
    path: "/raporgunlukisler",
    name: "raporgunlukisler",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "raporgunlukisler.Baslik",
      yetki: { k: [2000502] },
    },
  },
]
